import React, {useState} from "react";
import {Button, Checkbox, Input, message, Modal, Row, Select, Table, Upload} from "antd";
import moment from "moment";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import {UploadOutlined} from "@ant-design/icons";
import {useFormik} from "formik";
import * as Yup from "yup";
import {DocumentModal} from "../documents/documentModal";

const {Option} = Select;

const ContractTemplateManagement = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
    const [isDocumentModalVisible, setIsDocumentModalVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [documentUrl, setDocumentUrl] = useState(null);
    const [isDisplayNameEditable, setIsDisplayNameEditable] = useState(false);

    const [loading, data, setData] = useFetch({
        fetchFn: stores.contractStore.getContractTemplates.bind(null, {}),
        dependencies: [currentPage, reloadData]
    });

    const templateFormik = useFormik({
        initialValues: {
            templateDisplayName: "",
            selectedTemplateFile: null
        },
        validationSchema: Yup.object({
            templateDisplayName: Yup.string().required("Lütfen bir şablon gösterim adı girin!"),
            selectedTemplateFile: Yup.mixed().required("Lütfen bir dosya seçin!")
        }),
        onSubmit: async values => {
            setIsSubmitting(true);
            try {
                const formData = new FormData();
                formData.append("contractName", "serviceAgreement");
                formData.append("displayName", values.templateDisplayName);
                formData.append("file", values.selectedTemplateFile);

                await stores.contractStore.createTemplate(formData);
                message.success("Şablon başarıyla eklendi!");
                setIsTemplateModalVisible(false);
                setReloadData(!reloadData);
                setIsDisplayNameEditable(false);
                templateFormik.resetForm();
            } catch (error) {
                message.error("Şablon eklenirken bir hata oluştu.");
            } finally {
                setIsSubmitting(false);
            }
        }
    });

    const handleShowDocument = record => {
        setDocumentUrl(record.publicUrl);
        setIsDocumentModalVisible(true);
    };

    const handleDeactivateContractTemplate = async record => {
        try {
            await stores.contractStore.changeContractTemplateActivation({
                templateId: record?._id,
                isActive: false
            });

            console.log("Deactivation successful");
            setReloadData({});
        } catch (error) {
            console.error("Deactivation failed: ", error);
            message.error("Şablon devre dışı bırakılırken hata oluştu!");
        }
    };

    return (
        <div>
            <Row justify="end" style={{marginBottom: 16}}>
                <Button type="primary" onClick={() => setIsTemplateModalVisible(true)}>
                    Yeni Şablon Yükle
                </Button>
            </Row>
            <Table
                loading={loading}
                dataSource={data || []}
                rowKey="_id"
                pagination={{
                    current: currentPage,
                    onChange: setCurrentPage,
                }}
            >
                <Table.Column title="Şablon Adı" dataIndex="displayName" />
                <Table.Column
                    title="Oluşturulma Tarihi"
                    dataIndex="createdAt"
                    render={date => (date ? moment(date).format("DD.MM.YYYY") : "-")}
                />
                <Table.Column
                    title="Görüntüle"
                    render={(text, record) =>
                        record.publicUrl ? (
                            <Button onClick={() => handleShowDocument(record)}>Görüntüle</Button>
                        ) : (
                            "-"
                        )
                    }
                />
                <Table.Column
                    title="Devre Dışı Bırak"
                    render={(text, record) =>
                        !record.isArchived ? (
                            <Button onClick={() => handleDeactivateContractTemplate(record)}>
                                Devre Dışı Bırak
                            </Button>
                        ) : (
                            "-"
                        )
                    }
                />
            </Table>

            <DocumentModal
                visibility={isDocumentModalVisible}
                onCancel={() => setIsDocumentModalVisible(false)}
                documentUrl={documentUrl}
                title="Belge Görüntüleyici"
            />

            <Modal
                title="Yeni Şablon Ekle"
                visible={isTemplateModalVisible}
                onCancel={() => {
                    setIsTemplateModalVisible(false);
                    templateFormik.resetForm();
                }}
                onOk={() => templateFormik.submitForm()}
                okText="Ekle"
                cancelText="İptal"
                confirmLoading={isSubmitting}
            >
                <Input
                    placeholder="Şablon gösterim adı girin"
                    style={{ marginBottom: 16 }}
                    value={templateFormik.values.templateDisplayName}
                    onChange={e => templateFormik.setFieldValue("templateDisplayName", e.target.value)}
                    onBlur={templateFormik.handleBlur("templateDisplayName")}
                />
                {templateFormik.touched.templateDisplayName && templateFormik.errors.templateDisplayName ? (
                    <div style={{ color: "red" }}>{templateFormik.errors.templateDisplayName}</div>
                ) : null}

                <Upload
                    beforeUpload={file => {
                        templateFormik.setFieldValue("selectedTemplateFile", file);
                        return false;
                    }}
                    maxCount={1}
                    fileList={
                        templateFormik.values.selectedTemplateFile
                            ? [templateFormik.values.selectedTemplateFile]
                            : []
                    }
                    onRemove={() => templateFormik.setFieldValue("selectedTemplateFile", null)}
                >
                    <Button icon={<UploadOutlined />}>Dosya Seç</Button>
                </Upload>
                {templateFormik.touched.selectedTemplateFile && templateFormik.errors.selectedTemplateFile ? (
                    <div style={{ color: "red" }}>{templateFormik.errors.selectedTemplateFile}</div>
                ) : null}
            </Modal>
        </div>
    );
};

export {ContractTemplateManagement};
